import { useQuery } from '@tanstack/react-query'

import { GetParametrosSimulacao } from '@/features/simulador/brasil/http'
import { parametrosKeys } from '@/utils/parametros-query-keys'

export const useParametrosSimulacao = (idExternoEmpreendimento: string) => {
  return useQuery({
    queryKey: parametrosKeys.simulacao(idExternoEmpreendimento),
    queryFn: async () => new GetParametrosSimulacao().execute(idExternoEmpreendimento).then((res) => res.data),
  })
}
